import { cx } from "../util/classnames";

export type Tab = "gallery" | "upload";

type Props = { current: Tab; onChange: (next: Tab) => void };

export function TabBar({ current, onChange }: Props) {
  return (
    <nav
      className={cx(
        "flex shrink-0 items-stretch border-ink/10 bg-paper",
        "fixed inset-x-0 bottom-0 z-20 border-t md:static md:border-b md:border-t-0",
      )}
    >
      <TabButton label="Galleria" active={current === "gallery"} onClick={() => onChange("gallery")} />
      <TabButton label="Lähetä kuvia" active={current === "upload"} onClick={() => onChange("upload")} />
    </nav>
  );
}

function TabButton({ label, active, onClick }: { label: string; active: boolean; onClick: () => void }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cx(
        "flex-1 px-4 py-3 text-sm font-medium",
        active ? "border-b-2 border-ink text-ink" : "text-ink/60",
      )}
    >
      {label}
    </button>
  );
}
